
@if (targetingList?.portfolioMetadata) {
    <div class="agpr-portfolioEditor">
        <div class="agpr-portfolioEditor-fields">
            <agpr-checkbox
                [id]="id + '_visible'"
                label="Visible to Customers"
                [(ngModel)]="targetingList.portfolioMetadata.active"
                [binary]="true"
            ></agpr-checkbox>
    
            <agpr-text-input
                [id]="id + '_displayName_engUS'"
                label="English (us) display name"
                [(ngModel)]="targetingList.portfolioMetadata.enUSName"
                placeholder="Enter display name"
                (blur)="updateCanSave()"
            ></agpr-text-input>
    
            <agpr-text-input
                [id]="id + '_displayName_engGB'"
                label="English (gb) display name"
                [(ngModel)]="targetingList.portfolioMetadata.enGBName"
                placeholder="Enter display name"
                (blur)="updateCanSave()"
            ></agpr-text-input>
    
            <agpr-text-input
                [id]="id + '_displayName_frCA'"
                label="French (ca) display name"
                [(ngModel)]="targetingList.portfolioMetadata.frCAName"
                placeholder="Enter display name"
                (blur)="updateCanSave()"
            ></agpr-text-input>
            
            <agpr-text-input
                [id]="id + '_displayName_frFA'"
                label="French (fr) display name"
                [(ngModel)]="targetingList.portfolioMetadata.frFRName"
                placeholder="Enter display name"
                (blur)="updateCanSave()"
            ></agpr-text-input>
    
            <agpr-dropdown
                [id]="id + '_regionDropdown'"
                label="Region"
                placeholder="Select Region"
                [bindToValue]="true"
                [options]="portfolioRegions"
                [(ngModel)]="targetingList.portfolioMetadata.region"
                (ngModelChange)="updateCanSave()"
            ></agpr-dropdown>
    
            <agpr-dropdown
                [id]="id + '_categoryDropdown'"
                label="Category"
                placeholder="Select Category"
                [bindToValue]="true"
                [options]="portfolioCategories"
                [(ngModel)]="targetingList.portfolioMetadata.category"
                (ngModelChange)="updateCanSave()"
            ></agpr-dropdown>
    
            <agpr-dropdown
                [id]="id + '_sortByDropdown'"
                label="Default Sort Field"
                placeholder="Select Default Sort Order"
                [bindToValue]="true"
                [options]="sortFields"
                [(ngModel)]="targetingList.portfolioMetadata.defaultSortField"
                (ngModelChange)="updateCanSave()"
            ></agpr-dropdown>
        </div>
    
        <agpr-action-bar>
            <ng-template #right>
                <agpr-button
                    [id]="id + '_saveButton'"
                    [disabled]="!canSave"
                    label="Save Portfolio"
                    (click)="savePortfolio()"
                ></agpr-button>
            </ng-template>
        </agpr-action-bar>
    </div>
}

